import api from './api';

export const deleteExtraPayment = async (id, userId) => {
    try {
        const response = await api.delete(`/api/overtime/deleteExtraPay/${id}/${userId}`);
        return response.data.result;
    } catch (error) {
        return false;
    }
};

export const updateRequestsAsPay = async (userId, selectedIds, comments) => {
    try {
        const obj = {
            userId,
            requestsIds: selectedIds,
            comments
        };
        const response = await api.put('/api/overtime/updateRequestsAsPay', obj);
        return response.data.result;
    } catch (error) {
        return false;
    }
};

export const getRequestsToPay = async () => {
    try {
        const response = await api.get('/api/overtime/requestsToPay');
        return response.data;
    } catch (error) {
        return [];
    }
};